// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3CRmg","head":"Table_head__2RKs0","col":"Table_col___7Ic2"};